import {
  CONFIG_GOOGLE_AC_VENDOR_IDS,
  CONFIG_GOOGLE_AC_VERSION
} from '../config';
import {
  getTCString
} from './utils';
import {
  getPermissionFeature
} from './permission-feature';

/**
 * Returns the computed AC string for Google (Additional Consent String
 * @param {string} encodedTcString The tcString itself (optional)
 */
export function getACString(encodedTcString: string = getTCString()): string {
  let googleAcVendorIds: number[];
  try {
    googleAcVendorIds = JSON.parse(CONFIG_GOOGLE_AC_VENDOR_IDS);
  } catch (error) {
    googleAcVendorIds = [];
    console.error(error);
  }
  return `${CONFIG_GOOGLE_AC_VERSION}~${getPermissionFeature('googleAc', null, encodedTcString) ? googleAcVendorIds.join('.') : ''}`;
}